module.exports = __webpack_public_path__ + "img/Group7.48ebb107.svg";